var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gradient-overlay",class:{ 'top-to-bottom': _vm.topToBottom },style:(_vm.compSolidColor ? _vm.compSolidColor : '')})}
var staticRenderFns = []

export { render, staticRenderFns }